import { render, staticRenderFns } from "./SectionDocuments.vue?vue&type=template&id=c9043a64&scoped=true&"
import script from "./SectionDocuments.vue?vue&type=script&lang=ts&"
export * from "./SectionDocuments.vue?vue&type=script&lang=ts&"
import style0 from "./SectionDocuments.vue?vue&type=style&index=0&id=c9043a64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9043a64",
  null
  
)

export default component.exports